import React from "react";

const Post = ({id, username, Likes, Caption}) => {
    return (
    <div>
        <p> This is id: {id}</p>
        <p>This is username {username}</p>
        <p></p>
        <p></p>
        <p>This is  Likes {Likes}</p>
        <p>THis is Caption {Caption}</p>
        <p>Other Post:</p>
    </div>
    )
};

export default Post